<layout-default [options]="options"
                [nav]="navTpl"
                [content]="contentTpl"
                [customError]="null"
                appKeyboardShortcuts>

  <layout-default-header-item direction="left">
    <app-header-company-widget [collapsed]="isCollapsed" (showLicenseInfo)="showLicense()" [company]="company" />
  </layout-default-header-item>


  <layout-default-header-item direction="middle" [style.display]="isMobile() ? 'none' : ''">
    <header-search class="alain-default__search my-header-search"
                   [(toggleChange)]="searchToggleStatus"></header-search>
  </layout-default-header-item>


  <layout-default-header-item direction="right">
    <header-chat [mobileOrTablet]="isMobileOrTablet()" #chat></header-chat>
  </layout-default-header-item>


  <layout-default-header-item direction="right">
    <header-chatbot [hideIcon]="isMobileOrTablet()" #chatbot></header-chatbot>
  </layout-default-header-item>


  @if (isDesktop()) {
    <layout-default-header-item direction="right" style="margin-left: 25px;">
      <header-tour></header-tour>
    </layout-default-header-item>
  }

  <layout-default-header-item direction="right">
    <header-notify></header-notify>
  </layout-default-header-item>


  @if (isDesktop()) {
    <layout-default-header-item direction="right">
      <header-marketplace></header-marketplace>
    </layout-default-header-item>
  }

  @if (isDesktop()) {
    <layout-default-header-item direction="right">
      <header-support></header-support>
    </layout-default-header-item>
  }


  @if (isMobileOrTablet()) {
    <layout-default-header-item direction="right">
      <header-mobile-dropdown-nav
        [showSearchIcon]="isMobile()"
        (requestSearch)="onRequestSearch()"
        (requestAISupport)="onAISupport()"
        (requestChatbot)="onOpenChatbot()"
        (requestLock)="lockApp()">
      </header-mobile-dropdown-nav>
    </layout-default-header-item>
  }


  @if (isDesktop()) {
    <layout-default-header-item direction="right">
      <a layout-default-header-item-trigger (click)="lockApp()"
         nz-tooltip nzTooltipTitle="Lock" nzTooltipPlacement="bottom">
        <i nz-icon nzType="lock"></i>
      </a>
    </layout-default-header-item>
  }


  <layout-default-header-item direction="right">
    <header-user></header-user>
  </layout-default-header-item>

  <ng-template #navTpl>
    <div class="scrollbar">
      <app-nav class="d-block py-lg" />
    </div>
  </ng-template>

  <ng-template #contentTpl>
    <app-trial-banner />
    <reuse-tab #reuseTab (close)="closeTab($event)"></reuse-tab>
    <router-outlet (activate)="addTab(reuseTab, $event)" (attach)="addTab(reuseTab, $event)">
    </router-outlet>
    <global-footer [links]="[]">
      Copyright
      <i nz-icon nzType="copyright"></i> {{ this.copyrightYear }}
      <a href="{{ this.QNELink }}" target="_blank" rel="noopener">{{ this.companyName }}</a>
      {{ this.buildDisplay }}
    </global-footer>
  </ng-template>
</layout-default>

<app-page-how-to></app-page-how-to>

@if (showSettingDrawer) {
  <setting-drawer></setting-drawer>
}

@if (showSettingDrawer) {
  <theme-btn></theme-btn>
}

@if (company.isSample) {
  <app-init-sample [progress]="progress"></app-init-sample>
}

<financial-advisor-header></financial-advisor-header>
<app-license-notification></app-license-notification>
<app-mfa-prompt></app-mfa-prompt>
<app-prompt-card-runner></app-prompt-card-runner>

@if (qbotWidgetService.showReportAnalyzerWidget()) {
  <app-q-bot-report-analyzer />
}
